import i18n from 'es2015-i18n-tag';
import Button from '../button/button.component';
import { useNavigate } from 'react-router';

export interface BackButtonProps {
    className?: string;
}

export const BackButton = ({ className }: BackButtonProps) => {
    const navigate = useNavigate();

    return (
        <Button
            title={i18n`Abbrechen`}
            type="button"
            className={className}
            onClick={() => navigate(-1)}
        />
    );
};

export default BackButton;
